import { Injectable, SkipSelf } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvService } from 'src/app/env.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { ApiEndPointsDocument } from '../../common/apiUrls/api-end-points-document';
import { query } from '@angular/animations';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private baseUrl: any;
  private baseUrlTrans: any;
  private baseUrlUser: any;
  constructor(@SkipSelf() private _http: HttpClient,
    private apiAddress: ApiEndPointsDocument, public env: EnvService,
    private constant: Constants) {
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrl = this.constant.SettingsPortNumber;
    else
      this.baseUrl = this.env.apiUrl + this.constant.SettingsPortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlTrans = this.constant.ManageTranscationportNumber;
    else
      this.baseUrlTrans = this.env.apiUrl + this.constant.ManageTranscationportNumber;
      if (this.env.apiUrl == undefined || this.env.apiUrl == '')
        this.baseUrlUser = this.constant.ManageUserPortNumber;
      else
        this.baseUrlUser = this.env.apiUrl + this.constant.ManageUserPortNumber;
  }

  // private baseUrl = this.env.apiUrl;
  //private baseUrl = this.env.apiUrl+this.constant.ManageDocumentPortNumber;
  // private baseUrl = this.constant.ManageDocumentPortNumber;
  // private baseUrlTrans = this.constant.ManageTranscationportNumber;
  //private baseUrlTrans = this.env.apiUrl+this.constant.ManageTranscationportNumber;

  AddCoreDocumentFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddCoreDocumentFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllCoreDocumentFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAllCoreDocumentFolders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllCoreDocumentPlaceholders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAllCoreDocumentPlaceholders;
    return this._http.post(apiURL, reqModel).pipe();
  }


  AddCoreDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddCoreDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCoreItemForPlaceholder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddCoreItemForPlaceholder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UploadCoreDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UploadCoreDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCoreMultiDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddCoreMultiDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UploadCoreMultiDocumentPCC(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UploadCoreMultiDocumentPCC;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetDocumentCategoriesPCC(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetDocumentCategoriesPCC;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UploadDocumenttoPCC(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UploadDocumenttoPCC;
    return this._http.post(apiURL, reqModel).pipe();
  }

  deleteDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.deleteDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteCorePlaceholder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteCorePlaceholder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getDocumentsByFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getDocumentsByFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getDocumentsDetailByDocumentId(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getDocumentsDetailsByDocumentId;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateDocumentsDetailByDocumentId(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UpdateDocumentsDetailsByDocumentId;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  RenameCoreDocumentFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.RenameCoreDocumentFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }
  appendTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.appendTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAllTemplates(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getAllTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetDocumentTemplatePlaceholders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetDocumentTemplatePlaceholders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteCoreDocumentFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteCoreDocumentFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // getAttachment(fileName): Observable<any> {
  //   const queryParam = '?fileName=' + fileName    
  //   const apiURL = this.baseUrl + this.apiAddress.getAttachment + '' + queryParam;
  //   return this._http.get(apiURL).pipe();
  // }
  getAttachment(fileName, filePath): Observable<any> {
    const queryParam = '?fileName=' + filePath;
    const apiURL = this.baseUrlTrans + this.apiAddress.getAttachment + '' + queryParam;
    return this._http.get(apiURL).pipe();
  }


  DownloadDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DownloadDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCoreDocumentfromMyDrive(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddCoreDocumentfromMyDrive;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCreateProjectforPlaceholder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddCreateProjectforPlaceholder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ReorderFormGroupRelations(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ReorderFormGroupRelations;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddEditProjectGroupRelationParticipant(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddEditProjectGroupRelationParticipant;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetContactListCoreImplementation(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetContactListCoreImplementation;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectInfoAsTemplete(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddProjectInfoAsTemplete;
    return this._http.post(apiURL, reqModel).pipe();
  }

  FillPlaceholder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.FillPlaceholder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllDocumentOfProject(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAllDocumentOfProjectURL;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectEventLog(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddProjectEventLog;
    return this._http.post(apiURL, reqModel).pipe();
  }

  Reorderfolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.Reorderfolders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ReorderPlaceholders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ReorderPlaceholders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ReorderPlaceholdersforNewAddedPlaceholders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ReorderPlaceholdersforNewAddedPlaceholder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ReorderfoldersforNewAddedfolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ReorderfoldersforNewAddedfolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  extractDocumentData(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.extractDocumentData;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetFieldForImportExport(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.GetFieldForImportExport;
    return this._http.post(apiURL, reqModel).pipe();
  }


  addFormKeyAsNewFields(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.addFormKeyAsNewFields;
    return this._http.post(apiURL, reqModel).pipe();
  }

  mergePdfFiles(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.mergePdfFiles;
    return this._http.post(apiURL, reqModel).pipe();
  }

  shareDocsOnPortal(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.shareDocsOnPortal;
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.searchCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameCoreDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.renameCoreDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetUserList(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.GetUserList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  autoFillPlaceholderForms(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.autoFillPlaceholderForms;
    return this._http.post(apiURL, reqModel).pipe();
  }

  autoFillCoreDataintoProject(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.autoFillCoreDataintoProject;
    return this._http.post(apiURL, reqModel).pipe();
  }

  setProcessStageForCoreDocumentFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.setProcessStageForCoreDocumentFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  processNTAOnGivenDocuments(reqModel): Observable<any> {
     const apiURL = this.baseUrlTrans + this.apiAddress.processNTAOnGivenDocuments;   
     return this._http.post(apiURL, reqModel).pipe();
   }

}
